import { normalizePath } from './sanitize-location'

/**
 * The marketing surface — the ONLY paths where Google Analytics is allowed to
 * send. Exact-match (after trailing-slash normalization) so a future
 * `/legal/anything-private` or a renamed authed route can't silently leak in.
 *
 * Why this exists even though GA only mounts in the (marketing) route group:
 * the route-group boundary stops a COLD load of an authed page from rendering
 * GA, but it does NOT unload gtag.js after a client-side <Link> navigation out
 * of (marketing) (e.g. / → /signup). gtag.js + its history listener survive
 * the SPA transition. `isMarketingPath` drives a root-level kill-switch
 * (`window['ga-disable-<ID>']`) so GA goes silent the instant the user soft-
 * navigates onto any non-marketing path. See ga-route-guard.tsx.
 */
const GA_MARKETING_ROUTES = new Set([
  '/',
  '/our-story',
  '/storyworth-alternative',
  // BAO-129: the gift landing page only. /gift/thank-you and /gift/welcome
  // render a buyer's or recipient's details and live outside (marketing).
  '/gift',
  '/legal/privacy',
  '/legal/cookies',
  '/legal/terms',
  '/legal/unsubscribe',
])

export function isMarketingPath(pathname: string): boolean {
  return GA_MARKETING_ROUTES.has(normalizePath(pathname || '/'))
}
